import styled from 'styled-components';

const SubTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: bold;

  margin-block-start: 1rem;
  margin-block-end: 1rem;
`;

export default SubTitle;
